import styled, { css } from 'styled-components';

import type { EventsVariants } from 'Theme/types/components.type';

import ArrowLink from 'Elements/Link/Arrow';

export const Container = styled.div`
    ${({ theme }) => css`
        padding: 1.25rem;
        border-radius: 0.5rem;
        background: ${theme.colors.primaryContrast.hex};
        z-index: 1;
        position: relative;
    `}
`;

export const Heading = styled.h2`
    ${({ theme }) => css`
        margin: 0;
        font-size: 1.125rem;
        letter-spacing: 0;
        text-transform: none;
        font-weight: 700;

        @media ${theme.breakpoints.xlarge.media} {
            font-size: 1.875rem;
        }
    `}
`;

export const Text = styled.p`
    margin: 1.25rem 0 1.75rem;
    max-width: 56.25rem;
`;

export const EventItem = styled.div<{ $variant: EventsVariants }>`
    ${({ theme, $variant }) => css`
        margin-top: 0.5rem;
        background: ${$variant in theme.components.events
            ? theme.components.events[$variant].background
            : theme.components.events['default'].background};
        border-radius: 0.5rem;
        padding: 0.5rem 0.75rem;

        @media ${theme.breakpoints.large.media} {
            margin-top: 1rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        @media ${theme.breakpoints.xlarge.media} {
            padding: 0.75rem 1.25rem;
        }
    `}
`;

export const EventTitle = styled.p`
    ${({ theme }) => css`
        font-size: 1.125rem;
        line-height: 1.15;
        font-weight: 700;
        margin: 0;

        @media ${theme.breakpoints.medium.media} {
            width: auto;
            max-width: 80%;
        }

        @media ${theme.breakpoints.xlarge.media} {
            font-size: 1.875rem;
        }
    `}
`;

export const EventDate = styled.span`
    ${({ theme }) => css`
        display: block;
        font-size: 1.125rem;
        font-weight: 300;
        margin-top: 0.25rem;

        @media ${theme.breakpoints.large.media} {
            font-size: 1.5rem;
        }
    `}
`;

export const StyledLink = styled(ArrowLink)`
    ${({ theme }) => css`
        font-size: 1.125rem;
        font-weight: 700;
        white-space: nowrap;
        margin-top: 0.25rem;

        @media ${theme.breakpoints.large.media} {
            font-size: 1.5rem;
            margin-top: 0;
        }
    `}
`;
